import type { ReactNode } from 'react'
import { useUser } from '@/auth/useAuth'
import { can, type Capability } from '@/auth/rbac'
import { EmptyState } from '@/ui'

/** Route guard: render children only if the current role has the capability. */
export function RequireCapability({
  capability,
  children,
}: {
  capability: Capability
  children: ReactNode
}) {
  const user = useUser()
  if (!can(user.role, capability)) {
    return (
      <EmptyState
        title="Нет доступа"
        hint="Этот раздел доступен только для определённых ролей."
      />
    )
  }
  return <>{children}</>
}
